import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import routes from "@/lib/routes";
import ChatMessageReportStepInit from "./ChatMessageReportStepInit";
import ChatMessageReportStepMute from "./ChatMessageReportStepMute";
import ChatMessageReportStepReport from "./ChatMessageReportStepReport";
import { useChatReportMessageMutation } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ChatMessageReportModal = props => {
  const {
    0: mode,
    1: setMode
  } = useState("init");
  const reportCompleteHandle = useCallback(id => {
    props.handleReportComplete(id);
    props.reportComplete();
  }, [props]);
  const [reportChatMessageMutation] = useChatReportMessageMutation({
    onCompleted: _ref => {
      let {
        chatReportMessage
      } = _ref;
      console.log(chatReportMessage === null || chatReportMessage === void 0 ? void 0 : chatReportMessage.result);
      // 必要あれば通報したメッセージを消去する処理を追加
      reportCompleteHandle(props.id);
    },
    onError: e => {
      console.log("error on reportMessage:", e);
    }
  });
  const setStepInit = useCallback(() => {
    setMode("init");
  }, []);
  const setStepMute = useCallback(() => {
    setMode("mute");
  }, []);
  const setStepReport = useCallback(() => {
    setMode("report");
  }, []);
  const childProps = _objectSpread(_objectSpread({}, props), {}, {
    setStepInit: setStepInit,
    setStepMute: setStepMute,
    setStepReport: setStepReport
  });
  const reportSend = (id, reason) => {
    if (!reason) return;
    reportChatMessageMutation({
      variables: {
        roomId: props.roomId,
        messageId: id,
        reason: reason
      }
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: modalStyles.container,
      children: [mode === "init" && /*#__PURE__*/_jsx(ChatMessageReportStepInit, _objectSpread(_objectSpread({}, childProps), {}, {
        reportedMessageIds: props.reportedMessageIds
      })), mode == "mute" && /*#__PURE__*/_jsx(ChatMessageReportStepMute, _objectSpread({}, childProps)), mode == "report" && /*#__PURE__*/_jsx(ChatMessageReportStepReport, _objectSpread(_objectSpread({}, childProps), {}, {
        handleReportSend: reportSend
      }))]
    })
  });
};
export default ChatMessageReportModal;